module.exports = __webpack_public_path__ + "img/choco-shake-vignette.fa6a4e61.jpg";